import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import Text from 'components/Text';
import TextLink from 'components/TextLink';

import {getUrlServiceHref} from 'utils/getUrlServiceHref';
import config from 'utils/config';

const ExternalLink = ({children, href, ...otherProps}) => (
	<TextLink
		bold
		rel="noopener noreferrer"
		target="_blank"
		href={getUrlServiceHref(href)}
		{...otherProps}
	>
		{children}
	</TextLink>
);

function TranslatedMessage({clientLink, clientLinkLabel}) {
	const {t} = useTranslation();

	if (!clientLinkLabel) {
		return (
			// prettier-ignore
			<Trans t={t} i18nKey="powered_by_5app">
				Powered by <ExternalLink href="https://5app.com" title="5app Ltd">5app</ExternalLink>
			</Trans>
		);
	}

	return (
		// prettier-ignore
		<Trans t={t} i18nKey="powered_by_5app_and_client" client={clientLinkLabel}>
			<ExternalLink href={clientLink}>`${clientLinkLabel}`</ExternalLink> - Powered by <ExternalLink href="https://5app.com" title="5app Ltd">5app</ExternalLink>
		</Trans>
	);
}

function PoweredBy5app() {
	let clientLink;
	let clientLinkLabel;
	if (config.poweredBy) {
		clientLink = config.poweredBy.url;
		clientLinkLabel = config.poweredBy.title;
	}

	return (
		<Text dimmed as="footer" size="s" align="center" p="s" mt="auto">
			<TranslatedMessage
				clientLink={clientLink}
				clientLinkLabel={clientLinkLabel}
			/>
		</Text>
	);
}

export {TranslatedMessage};

export default PoweredBy5app;
